<script>
import formDialogCreate from '@/components/iglobalwin/formDialog';
import formPanelCreate from '@/components/iglobalwin/form-warps/dialog-form-panel/dialog-form-panel.js';
import googleads from '@/backend/services/googleAds/googleAds.js';
import { validRequired } from '@/common/elementValid.js';
import { getDefaultData } from '../js/reportConfiguration';

let detailsListOptions = [
	{
		label: '日期报告',
		value: 1,
	},
	{
		label: '询盘报告',
		value: 2,
	},
	{
		label: '广告系列报告',
		value: 3,
	},
	{
		label: '国家/地区报告',
		value: 4,
	},
	{
		label: '关键词报告',
		value: 5,
	},
	{
		label: '搜索词报告',
		value: 6,
	},
	{
		label: '网络报告',
		value: 7,
	},
	{
		label: '设备报告',
		value: 8,
	},
];

function getFormData(_obj, vm) {
	let { attributes } = vm;
	let { id, type, name, detailsList } = attributes;
	let arr = [];
	if (id) {
		detailsList.forEach(item => {
			if (item.status) arr.push(item.type);
		});
	} else {
		arr = detailsListOptions.map(item => {
			return item.value;
		});
	}
	return {
		type: {
			label: '模板类型：',
			formType: 'sky-text',
			value: type || 1,
			dataStyle: () => {
				if (type === 1) return '个人模板';
				return '系统模板';
			},
			rules: [
				{
					required: true,
					trigger: 'blur',
					validator: (_rule, _value, callback) => {
						if (callback) {
							return undefined;
						}
						return '请选择模板类型';
					},
				},
			],
		},
		name: {
			label: '模板名称：',
			formType: 'sky-input',
			value: name || '',
			rules: [validRequired('请填写模板名称')],
		},
		detailsList: {
			label: '选择报告模块：',
			formType: 'sky-checkbox',
			value: arr,
			checkboxItemWidth: '110px',
			options: detailsListOptions,
			rules: [
				{
					required: true,
					trigger: 'blur',
					validator: (_rule, _value, callback) => {
						if (callback.length > 0) {
							return undefined;
						}
						return '请选择报告模块';
					},
				},
			],
		},
	};
}

async function submit(data) {
	try {
		let { attributes } = this;
		let { id = null } = attributes;
		let { detailsList } = data;
		data.detailsList = detailsListOptions.map(item => {
			return {
				dto: getDefaultData(item.value),
				status: detailsList.includes(item.value),
				type: item.value,
			};
		});
		data = {
			id,
			...data,
		};
		await googleads.addReportTemplate(data);
		this.$message.success('操作成功');
		this.$emit('confirm');
	} catch (error) {
		this.$message.error('操作失败');
		this.formData.loading = false;
	}
}

function cancel(self) {
	self.$emit('cancel');
}

function onShowLoad(props) {
	return props;
}

const componentForm = formPanelCreate(
	{
		getFormData,
		submit,
		cancel,
	},
	{
		labelWidth: '130px',
	}
);

export default formDialogCreate({
	name: 'addTemplateForm',
	onShowLoad,
	componentForm,
});
</script>

<style scoped lang="scss"></style>
